export default {"src":"/_next/static/media/bsc-testnet.cd43aea4.svg","height":24,"width":24};